import type { DesignTokens } from "../types/theme";

const WEB_SYSTEM_FONT =
  "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

/**
 * Base tokens for Light mode.
 */
export const LIGHT_BASE_TOKENS: DesignTokens = {
  background: "#f7f7f7",
  foreground: "#210331",
  surface: "#ffffff",
  surfaceForeground: "#210331",
  surfaceSecondary: "#f2f2f2",
  surfaceSecondaryForeground: "#210331",
  surfaceTertiary: "#ebebeb",
  surfaceTertiaryForeground: "#210331",
  overlay: "#ffffff",
  overlayForeground: "#210331",
  muted: "#71717a",
  default: "#f4f4f5",
  defaultForeground: "#210331",
  accent: "#16a34a",
  accentForeground: "#ffffff",
  danger: "#f43f5e",
  dangerForeground: "#ffffff",
  warning: "#f59e0b",
  warningForeground: "#210331",
  success: "#16a34a",
  successForeground: "#ffffff",
  separator: "#b8b8ba",
  glassBackground: "rgba(255, 255, 255, 0.85)",
  glassBorder: "rgba(0, 0, 0, 0.1)",
  glassHighlight: "rgba(0, 0, 0, 0.08)",
  glow0: "rgba(22, 163, 74, 0.12)",
  glow1: "rgba(244, 99, 72, 0.09)",
  glow2: "rgba(34, 197, 94, 0.08)",
  mutedForeground: "#210331",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.1)",
  overlayShadow: "rgba(0, 0, 0, 0.1)",
  fieldShadow: "rgba(0, 0, 0, 0.1)",
  fieldBorder: "rgba(0, 0, 0, 0.1)",
  fieldPlaceholder: "rgba(0, 0, 0, 0.4)",
  fieldBackground: "rgba(0, 0, 0, 0.03)",
  segment: "#ffffff",
  segmentForeground: "#210331",
  link: "#210331",
  focus: "#16a34a",
  fieldForeground: "#210331",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#b8b8ba",
  primary: "#16a34a",
  primaryForeground: "#ffffff",
  secondary: "#f4f4f5",
  secondaryForeground: "#210331",
  backdrop: "rgba(0, 0, 0, 0.5)",
};

/**
 * Base tokens for Dark mode.
 */
export const DARK_BASE_TOKENS: DesignTokens = {
  background: "#000000",
  foreground: "#fafafa",
  surface: "#210331",
  surfaceForeground: "#fafafa",
  surfaceSecondary: "#26063b",
  surfaceSecondaryForeground: "#fafafa",
  surfaceTertiary: "#33084d",
  surfaceTertiaryForeground: "#fafafa",
  overlay: "#2a0640",
  overlayForeground: "#fafafa",
  muted: "#a1a1aa",
  default: "#450a6e",
  defaultForeground: "#fafafa",
  accent: "#22c55e",
  accentForeground: "#06250f",
  danger: "#e11d48",
  dangerForeground: "#ffffff",
  warning: "#f59e0b",
  warningForeground: "#210331",
  success: "#22c55e",
  successForeground: "#06250f",
  separator: "#610e9c",
  glassBackground: "rgba(10, 10, 10, 0.985)",
  glassBorder: "rgba(255, 255, 255, 0.12)",
  glassHighlight: "rgba(255, 255, 255, 0.25)",
  glow0: "rgba(34, 197, 94, 0.45)",
  glow1: "rgba(244, 99, 72, 0.38)",
  glow2: "rgba(22, 163, 74, 0.3)",
  mutedForeground: "#fafafa",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.1)",
  overlayShadow: "rgba(0, 0, 0, 0.1)",
  fieldShadow: "rgba(0, 0, 0, 0.1)",
  fieldBorder: "rgba(255, 255, 255, 0.1)",
  fieldPlaceholder: "rgba(255, 255, 255, 0.4)",
  fieldBackground: "rgba(255, 255, 255, 0.03)",
  segment: "#650f9d",
  segmentForeground: "#fafafa",
  link: "#fafafa",
  focus: "#22c55e",
  fieldForeground: "#fafafa",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#610e9c",
  primary: "#22c55e",
  primaryForeground: "#06250f",
  secondary: "#450a6e",
  secondaryForeground: "#fafafa",
  backdrop: "rgba(0, 0, 0, 0.7)",
};
